import React from "react";
import { Space, Empty, Button } from "antd";
import PropTypes from "prop-types";
import { EditOutlined, LockOutlined } from "@ant-design/icons";

function EmployeeProfileAbotPage({
  oneEmployeeData,
  setModalOpen,
  loginData,
  setPassChange,
}) {
  return (
    <div className="bg-white basis-full min-h-[475px] h-max mb-5 p-5 rounded-xl">
      <div className="flex justify-between">
        <span className=" text-[#555555] text-xl font-bold">About</span>
        {loginData._id === oneEmployeeData[0]?._id ? (
          <div>
            <Button
              className="border-blue-500 mr-1"
              icon={<LockOutlined className="text-blue-500" />}
              onClick={() => setPassChange(true)}
            >
              <span className="text-blue-500">Change Password</span>
            </Button>
            <Button
              type="primary"
              className="bg-blue-500"
              icon={<EditOutlined />}
              onClick={() => setModalOpen(true)}
            >
              Edit
            </Button>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className=" flex justify-between mt-5 ">
        <Space direction="vertical">
          <span className="font-bold text-[#555555]">Full Name</span>
          <span>
            {oneEmployeeData?.length > 0
              ? `${oneEmployeeData[0].firstName} ${oneEmployeeData[0].lastName}`
              : "-"}
          </span>
        </Space>
        <Space direction="vertical">
          <span className="font-bold text-[#555555]">Mobile</span>
          <span>
            {oneEmployeeData[0]?.mobile ? `${oneEmployeeData[0].mobile}` : "-"}
          </span>
        </Space>
        <Space direction="vertical">
          <span className="font-bold text-[#555555]">Email</span>
          <span>
            {oneEmployeeData[0]?.email ? `${oneEmployeeData[0].email}` : "-"}
          </span>
        </Space>
        <Space direction="vertical">
          <span className="font-bold text-[#555555]">Employee ID</span>
          <span>
            {oneEmployeeData[0]?.empId ? `${oneEmployeeData[0].empId}` : "-"}
          </span>
        </Space>
      </div>
      <div className=" flex justify-between mt-5 ">
        <Space direction="vertical">
          <span className="font-bold text-[#555555]">Bank Name</span>
          <span>
            {oneEmployeeData?.length > 0
              ? `${oneEmployeeData[0].bankName}`
              : "-"}
          </span>
        </Space>
        <Space direction="vertical">
          <span className="font-bold text-[#555555]">Account Number</span>
          <span>
            {oneEmployeeData[0]?.bankAccountNumber ? `${oneEmployeeData[0].bankAccountNumber}` : "-"}
          </span>
        </Space>
        <Space direction="vertical">
          <span className="font-bold text-[#555555]">Aadhaar Number</span>
          <span>
            {oneEmployeeData[0]?.aadhaarNumber ? `${oneEmployeeData[0].aadhaarNumber}` : "-"}
          </span>
        </Space>
        <Space direction="vertical">
          <span className="font-bold text-[#555555]">PAN Number</span>
          <span>
            {oneEmployeeData[0]?.panNumber ? `${oneEmployeeData[0].panNumber}` : "-"}
          </span>
        </Space>
      </div>
      <div className=" flex gap-24 mt-5">
        <Space direction="vertical">
          <span className="font-bold text-[#555555]">ESI Number</span>
          <span>
            {oneEmployeeData[0]?.esiNumber ? `${oneEmployeeData[0].esiNumber}` : "-"}
          </span>
        </Space>
        <Space direction="vertical">
          <span className="font-bold text-[#555555]">UAN Number</span>
          <span>
            {oneEmployeeData[0]?.uanNumber ? `${oneEmployeeData[0].uanNumber}` : "-"}
          </span>
        </Space>
      </div>
      <p className="mt-10 text-[#555555] text-xl font-bold">Education</p>
      <Space.Compact
        direction="vertical"
        className="mt-5 w-full justify-center"
      >
        {oneEmployeeData[0]?.education?.length > 0 ? (
          oneEmployeeData[0].education.map((detail, index) => {
            if (detail.regulation === "UG" || detail.regulation === "Other") {
              return (
                <span
                  key={index}
                >{`${detail.course} ${detail.specialization} board at ${detail.boardName} with a  ${detail.mark} CGPA in ${detail.year}`}</span>
              );
            } else {
              return (
                <span
                  key={index}
                >{`${detail.regulation} board at ${detail.boardName} with a  ${detail.mark} Percentage in ${detail.year}`}</span>
              );
            }
          })
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </Space.Compact>
      <p className="mt-10 text-[#555555] text-xl font-bold">Experience</p>
      <Space.Compact
        direction="vertical"
        className="mt-5 w-full justify-center"
      >
        {oneEmployeeData[0]?.experience?.length > 0 ? (
          oneEmployeeData[0]?.experience.map((detail, index) => {
            if (detail.year.years === 0) {
              return (
                <span
                  key={index}
                >{`${detail.year.months} Month Experience in ${detail.designation} in the Organisation ${detail.details}`}</span>
              );
            } else {
              return (
                <span
                  key={index}
                >{`${detail.year.years} Year and ${detail.year.months} Month Experience in ${detail.designation} in the Organisation ${detail.details}`}</span>
              );
            }
          })
        ) : (
          <Empty className="mt-9" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </Space.Compact>
    </div>
  );
}
EmployeeProfileAbotPage.propTypes = {
  oneEmployeeData: PropTypes.array,
  setModalOpen: PropTypes.func,
  loginData: PropTypes.object,
  setPassChange: PropTypes.func,
  readOnly: PropTypes.bool,
};
export default EmployeeProfileAbotPage;
